<template lang="pug">
  .main
    .super-container(:style='topStyle' :class="tabCode==='ladder'?'super-container-ladder':''")
      .haveData(v-if="haveData")
        VipRecommendWords(v-if="newH5Version() && (vipRecommendText || vipRecommendPic)" :vipRecommendText="vipRecommendText" :vipRecommendPic="vipRecommendPic")
        .ladder-have-test
          FreeRights(
            v-if="freeRightsVersion() && freeRightsData"
            :moduleData="freeRightsData"
            :isOpen="false"
            @clickFreeRight="openCommonBonus(freeRightDisplayItem, false, 0 )")
          //- 头部推荐文字模块
          template(v-if="!newH5Version()")
            img.purchase-one-cent(v-if="propVersion === PropVersionMap.RIDE_ONE_CENT" :src="oneCentRideRecommendImg")
            ladderHeader(v-else-if="showSpecialExpiredAb" :expiredUserInfo="expiredUserInfoDTO")
            .purchase-block(v-else-if="cardPurchaseSuggestionDTO && !showSpecialExpiredAb")
              .purchase-block-left
                .left-purchase-line-one
                  .left-purchase-line-one-word {{ cardPurchaseSuggestionDTO.tagSuggestion }}
                .left-purchase-line-two
                  span {{splitString(cardPurchaseSuggestionDTO.verbalTrick, cardPurchaseSuggestionDTO.highlight)[0]}}
                  span.red-word {{cardPurchaseSuggestionDTO.highlight}}
                  span {{splitString(cardPurchaseSuggestionDTO.verbalTrick, cardPurchaseSuggestionDTO.highlight)[2]}}
          ladderTest.ladderTest(
            :isNewType="true"
            :groupList="groups"
            :zeroBuyCardShow="zeroBuyCardShow"
            :ladderDetailMap="ladderDetailMap"
            :ladderPropGroupList="ladderPropGroupList"
            :goodsList="goodsList"
            :newCustomer="newCustomer"
            :showStyleVersion="showStyleVersion"
            :showAppExpensive="showAppExpensive"
            :version="propVersion"
            :buyingAdviceAB="buyingAdviceAB"
            :cardPurchase="cardPurchaseSuggestionDTO"
            :bikeCardShowStyle="bikeCardShowStyle"
            :class="tabCode==='ladder'?'ladderTestbig':''"
          )
          .other-block-test
            .other-block-item(
              v-for="(item, index) in otherList",
              v-if="item.bonusEntity && item.bonusEntity.unPayImage"
              @click="openCommonBonus(item,true,index + groupsOther.length+testSecondList.length)"
            )
              .other-title-img(v-if="!freeRightsVersion()")
                .top-sign {{getSignleImg(index)}}
              img.under-img(:src="getImageUrl(item.bonusEntity && item.bonusEntity.unPayImage)")
          nba-super-card(@openModal="openNbaModal" :vipData="vipData")
          .bikeMonthCard(v-if="propVersion ==='ride_trial'&&currentRideCard&&zeroBuyCardShow")
            .card-top
              .icon
                img(src="https://m.hellobike.com/resource/helloyun/22871/sQNgk_Group%20576.png")
              .text 单车骑行月卡
            .card-bottom
              .left
                span.topContext 单车{{currentRideCard.useProperty.totalCardDays}}天不限次卡·生效中
                span.botContext 本月已有单车卡，到期自动续
              .right
                span 剩
                span.font  {{currentRideCard.remainDays}}
                span 天
          .no-use(v-if="fullRefundUnusedShowAb" @click="showNoUse")
            .no-use-left
              img.no-use-img(v-if="!freeRightsVersion()" src="https://m.hellobike.com/resource/gallery/61/1L7fasp87l.png")
              img.no-use-img(v-if="freeRightsVersion()" src="https://m.hellobike.com/resource/gallery/1022/vCfFiRI1Uw.png")
              div 未使用包退
            .no-use-right(@click="showNoUse")
              span 查看
              img.no-use-flag(v-if="!freeRightsVersion()" src="https://m.hellobike.com/resource/gallery/61/ZPRWm4DbLm.png")
              img.no-use-flag(v-if="freeRightsVersion()" src="https://m.hellobike.com/resource/gallery/1022/F2bpVKe8_Path%205%20(1).png")
          qaAndSuggest(:showQa="showQa" @goQa="goQa" @goSuggest="goSuggest")
          .rule-block(v-if="!env.isEasyBikeApp && !freeRightsVersion()" @click="rule") 规则 | 协议
          .shark-block
      //- .noData(v-else)
      //-   .noData-img
      //-     img.nodata-gif(
      //-       src="https://m.hellobike.com/resource/helloyun/08345/ptrfD33uJv.webp"
      //-     )
      //-   .noData-word 即将进入超级会员…
      vipButtonLadder(
        v-if="haveData&&!currentRideCard&&noSaleType!==2"
        ref="buttonNew",
        :info="price",
        :readSign="isRead"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
        :time="price.couponEndTime || 0"
        :unOpenShowCanBuy="unOpenShowCanBuy"
        :isIndex="true"
        :giftList="giftList"
        :propVersion="propVersion"
      )
      notakeEffect(v-if="noSaleType===2")
      vipButtonZeroBuy(
        v-if="haveData&&currentRideCard"
        ref="buttonNew",
        :info="price",
        :readSign="isRead"
        :currentRideCard="currentRideCard"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
        @priceChange="priceChange"
        :time="price.couponEndTime || 0"
        :unOpenShowCanBuy="unOpenShowCanBuy"
        :isIndex="true"
      )
      tip-modal(
        ref="tipModal",
        :mainTitle="mainTipTitle",
        :subTitle="subTipTitle"
        @goRenewalPage="goCardComplete"
      )
      appPrivilegeSuccess(
        :show.sync="showAppPrivilege"
        @goUrl="goUrl(config.deepLink,true)"
        @close="goCardComplete")

      feedback-popup(
      v-if="showFeedback"
      :show.sync="showFeedback"
      @close="closeScroll"
      @submit="feedbackSubmit")
      CompletedModal(
        ref="complete",
        @confirm="goCardComplete",
        :amount="save",
        :commonBonus="commonBonus",
        @close="goCardComplete"
      )
      onePageUpModal(
        ref="onepageup",
        @transTab="getTransTab",
        :type="1",
        :info="price",
        :time="price.couponEndTime || 0",
        :autoRenewalStatus="autoRenewalStatus",
        @closeOnePage="closeScroll",
        @openDialog="openDialog",
        @open="bayCardHandler",
        :commonBonus="commonBonus"
        :unOpenShowCanBuy="unOpenShowCanBuy"
        :showStyleVersion="showStyleVersion"
      )
      readModal(
        :show="showRead"
        @close="showRead=false"
        @readOk="readOk"
      )
      noUseBlock(
        :show.sync="showNoUseBolck"
      )
      visit-page-countdown(
        :env="Env"
      )
      nba-card-modal(
        :show.sync="nbaShow"
        :info="nbaPrice",
        :readSign="isRead"
        :time="nbaPrice.couponEndTime || 0"
        :unOpenShowCanBuy="unOpenShowCanBuy"
        :isIndex="true"
        :giftList="giftList"
        :propVersion="propVersion"
        @open="bayCardHandler",
        @openDialog="openDialog",
        @transTab="getTransTab",
        @isNoReadSign="openRead"
      )
  </template>

<script>

// import '@hb/task-h5-components/lib/countdown/visit-page';
import {
  buyVipGoods,
  tryTakeOrderStatus,
  getWaitPayOrder,
  closeVipGoods,
  showQa,
  submitFeedback,
} from '@/api/vip';
import config from '@/const/config';
import CommonHeader from '@/components/common-middle-header';
import { Native, env } from '@hb/hbridge';
import { redirectToCardComplete } from '@/utils/vip';
import {
  getTokenAndLocation,
  isPreRender,
  getNoScroll,
} from '@/utils';
import Toast from '@/components/toast';
// import Cashier from '@hb/h5-cashier';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import OpenSkeleton from '@/components/skeleton.vue';
import { CardService } from '@/service/card';
import { Storage } from '@/utils/storage';
import Picture from '@/components/picture';
import { startApp } from '@/utils/index';
import { PropVersionMap } from '@/const/vip';
import { oneCentRideRecommendImg } from '@/assets/imgAssets';
import { getImageUrl } from '@/utils/image';
import { Navigator } from '@hb/h5-navigator';
import CouponMore from '../coupon-more.vue';
import { getSource, getTokenAndKey } from '../../../../../utils';
import { ParamsUtil } from '../../../../../utils/params';
import { getSystemCode } from '../../../../../utils/systemCode';
import {
  ORDER_STATUS, RENEWAL_STATUS, RIGHT_TYPE, ORDER_TYPE,
} from '../../../consts';
import { UBTUtils } from '../../../../../utils/ubt';
import VipButtonNew from '../vip-button-new.vue';
import VipButton from '../vip-button.vue';
import TipModal from '../tip-modal.vue';
import nbaSuperCard from './nba-unopen-card.vue';
import nbaCardModal from './nba-card-modal.vue';
// import RetainModal from '../retain-modal'; // 挽留这个版本先不展示
import noPay from '../noPay';
import CompletedModal from '../completed-modal';
import onePageUpModal from '../one-page-up-modal';
import unOpenLineOne from '../unopen-line-one.vue';
import readModal from '../read-modal';
import vipButtonLadder from '../vip-button-ladder.vue';
import vipButtonZeroBuy from '../vip-button-zero-buy.vue';
import ladderTest from '../ladderTest.vue';
import ladderHeader from '../ladder-header.vue';
import expansionCss from '../expansion-css.vue';
import appPrivilegeSuccess from '../app-privilege-success.vue';
import { filterNoOpenData } from '../../utils';
import noUseBlock from '../no-use-block.vue';
import feedbackPopup from '../feedback-popup';
import qaAndSuggest from '../qa-and-suggest.vue';
import notakeEffect from './noTakeEffect.vue';
import FreeRights from './free-rights.vue';
import VipRecommendWords from './recommend-words.vue';

export default {
  components: {
    CommonHeader,
    OpenSkeleton,
    VipButtonNew,
    TipModal,
    // RetainModal,
    nbaSuperCard,
    nbaCardModal,
    noPay,
    CompletedModal,
    CouponMore,
    onePageUpModal,
    unOpenLineOne,
    readModal,
    vipButtonLadder,
    vipButtonZeroBuy,
    ladderTest,
    ladderHeader,
    Picture,
    expansionCss,
    appPrivilegeSuccess,
    noUseBlock,
    VipButton,
    feedbackPopup,
    qaAndSuggest,
    notakeEffect,
    FreeRights,
    VipRecommendWords,
  },
  props: {
    vipData: {
      type: Object,
      default: () => { },
    },
  },
  inject: ['freeRightsVersion', 'newH5Version', 'latestTabCode'], // 从父组件注入freeRightsVersion
  data() {
    return {
      // 订单操作类型常量
      ORDER_TYPE,
      config: {
        deepLink:
          'https://m.hellobike.com/mf/spa/u_wsjczx/latest/MA2204243054087163443937280.html?activityCode=MA2204243054087163443937280&beyondMP=true&chInfo=ch_share__chsub_CopyLink&fxzjshareChinfo=ch_share__chsub_CopyLink&apshareid=DAEF5627-8D33-4E6E-9CE2-2A0FD137329B&shareBizType=mrfxzw',
        wechatLink: 'https://m.hellobike.com/mf/spa/u_sxnpet/latest/MA2412037285359647643402840.html?activityCode=MA2412037285359647643402840',
      },
      showRenwal: true,
      zeroBuyCardShow: true,
      nbaShow: false,
      json: 'https://m.hellobike.com/resource/helloyun/08345/3ZiD4EFLNW.json',
      otherList: [],
      groups: [],
      commonBonus: [],
      save: '-',
      isNba: false,
      price: {
        goodsGuid: '',
        current: '',
        original: '39.9',
        days: 30,
        couponEndTime: 0,
        showPopUpWindowType: 0,
        signInfoDTO: {},
      },
      nbaPrice: {
        goodsGuid: '',
        current: '',
        original: '39.9',
        days: 30,
        couponEndTime: 0,
        showPopUpWindowType: 0,
        signInfoDTO: {},
      },
      willRetain: false, // 设置了挽留弹窗
      otherTotal: null,
      centerTitleLift: '',
      retainCoupon: {
        title: '-',
        subtitle: '-',
        amount: '-',
        centerTitleRight: '',
      },
      cashier: null,
      envValue: process.env.VUE_APP_ENV,
      groupsClass: {
        radius: false,
      },
      //    showAliNew: false,
      env,
      Env: config.env,
      showNopay: false,
      noPayData: {},
      mainTipTitle: '',
      subTipTitle: '',
      transType: 30,
      transPrice: 0,
      autoRenewalStatus: RENEWAL_STATUS.unavailable,
      RENEWAL_STATUS,
      groupsOne: [],
      groupsOther: [],
      haveData: false,
      testSecondList: {
        length: 0,
      },
      taurusTaskUnOpenShowSort: '', // 未开卡展示位置
      newUserImg: 'https://m.hellobike.com/resource/helloyun/08345/nLPo8mrlc1.png',
      oldUserImg: 'https://m.hellobike.com/resource/helloyun/08345/m2s22TpfYq.png',
      propVersion: 'ladder',
      newCustomer: true,
      groupList: [],
      ladderDetailMap: null,
      ladderPropGroupList: null,
      unOpenShowCanBuy: false,
      showRead: false,
      isRead: false,
      showQa: false,
      showStyleVersion: 'ladderEasy',
      goodsList: [], // 阶梯简版列表
      ladderTab: 0, // 阶梯切换tab
      groupLadderList: [], // 阶梯简版右侧卡券数据
      // unOpenPageShowStyle: null,
      showAppPrivilege: false,
      showAppExpensive: false, // 是不是膨胀券app版本
      currentRideCard: null, // 骑行体验卡卡数据
      showNoUseBolck: false, // 未使用退款说明弹窗
      fullRefundUnusedShowAb: false, // 未使用包退说明
      closeBuyTime: null,
      buyingAdviceAB: null,
      cardPurchaseSuggestionDTO: {},
      showSpecialExpiredAb: false,
      expiredUserInfoDTO: {},
      showFeedback: false,
      bikeCardShowStyle: null, // 单车助力车卡样式
      giftList: null,
      vipOpenData: null,
      noSaleType: null,
      unOpenCouponGameAB: false,
      redirectUrl: '',
      signPayChannels: [],
      payChannel: '',
      planId: '',
      freeRightsData: null,
      freeRightDisplayItem: null, // 点击免单特权组件 展示权益弹窗
      payActivityInfo: {},
      PropVersionMap,
      oneCentRideRecommendImg,
      curloopIntervalSecond: 0, // 轮询计数器
      orderTimer: null, // 轮询定时器引用
      payingFlag: false, // 正在支付标识符
    };
  },
  provide() {
    return {
      getPropVersion: () => this.propVersion,
      unOpenCouponGameAB: () => this.unOpenCouponGameAB,
      getSignPayChannels: () => this.signPayChannels,
    };
  },
  beforeRouteEnter(to, form, next) {
    UBT.pageView({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_newrules',
      contentId: 'platform_newrules',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
    // eslint-disable-next-line no-console
    console.log('页面进入');
  },
  beforeRouteLeave(to, form, next) {
    UBT.pageViewOut({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      businessInfo: {
        adsource: getSource(),
      },
    });
    next();
  },
  computed: {
    tabCode() {
      return this.latestTabCode();
    },
    topStyle() {
      if (this.tabCode === 'ladder' && !env.isEasyBikeApp) {
        return 'margin-top: 0.16rem;';
      }
      return '';
    },
  },
  watch: {
    'price.current': (newV) => {
      UBT.pageView({
        pageId: 'platform_savemoneycard_page',
        categoryId: 'platform',
        businessInfo: {
          price: newV,
          adsource: getSource(),
        },
      });
    },
    vipData: {
      async handler() {
        if (Object.keys(this.vipData).length > 0) {
          await this.getData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async created() {
    document.title = '超级会员';
    this.$emit('closeOpen', true);
    Storage.removeItem('isNoSign');
    const {
      finishPay, loopIntervalSecond,
      orderNo,
      loopTotalSecond,
    } = ParamsUtil.getParams(window.location.href);
    const { token } = await getTokenAndKey();
    if (finishPay) {
      this.searchStatus({
        loopIntervalSecond,
        orderNo,
        loopTotalSecond,
        token,
      }, null);
    }
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
      // eslint-disable-next-line no-useless-return
      return;
    }
    // this.initCashier();


    // window.addEventListener('popstate', () => {
    //   window.location.href = this.redirectUrl;
    // });
  },
  destroyed() {
    // if (this.willRetain && env.isEasyBikeApp) {
    //   window.removeEventListener('popstate', this.handleBack, false); // false阻止默认事件
    // }
    this.closeBuyTime = null;
    // 清理轮询定时器
    if (this.orderTimer) {
      clearTimeout(this.orderTimer);
      this.orderTimer = null;
    }
  },
  methods: {
    getImageUrl,
    openNbaModal(data) {
      this.nbaShow = true;
      this.nbaPrice = {
        ...this.price,
        ...data,
        current: data.price,
        original: data.markedPrice,
      };
    },
    splitString(fullStr, searchStr) {
      if (!fullStr) return [''];
      // 找到搜索字符串在完整字符串中的起始位置
      const startIndex = fullStr.indexOf(searchStr);
      // 如果搜索字符串不存在于完整字符串中，返回原字符串
      if (startIndex === -1) {
        return [fullStr];
      }
      // 分割字符串
      const part1 = `${fullStr.substring(0, startIndex)}`;
      const part2 = searchStr;
      const part3 = `${fullStr.substring(startIndex + searchStr.length)}`;
      return [part1, part2, part3];
    },
    goSuggest() {
      this.showFeedback = true;
    },
    async feedbackSubmit(point, info) {
      const { token } = await getTokenAndKey();
      await submitFeedback({
        token,
        point,
        info,
        systemCode: getSystemCode(),
        scene: 'propFeedBack',
      })
        .then((res) => {
          // 由于无res和code=103时都会走then，所以仅code=0 case为成功 关闭popup。
          if (res) {
            if (res.code === 0) {
              this.showFeedback = false;
              this.closeScroll();
              Toast.show('提交成功，感谢反馈');
            } else {
              Toast.showError(res.msg);
            }
          }
        })
        .catch((e) => Toast.showError(e));
      // this.isShowFeedbackRequest();
    },
    showNoUse() {
      this.showNoUseBolck = true;
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_refund',
        categoryId: 'platform',
        businessInfo: {},
      });
      UBT.moduleExpose({
        pageId: 'platform_savemoneycard_page',
        categoryId: 'platform',
        moduleId: 'platform_refund_rule',
        contentId: 'platform_refund_rule',
        exposureTimes: 1,
        businessInfo: {},
      });
    },
    goUrl(url = this.config.deepLink, download = false) {
      this.goCardComplete();
      if (download && (env.isAliMP || env.isAliMPMonitor)) {
        startApp(url);
        return;
      }
      if (env.isWeixin || env.isWechatMini) {
        window.location.href = (this.config.wechatLink);
        return;
      }
      window.location.href = url;
    },
    priceChange(val) {
      if (val === 1) {
        this.zeroBuyCardShow = true;
      } else {
        this.zeroBuyCardShow = false;
      }
    },
    getSignleImg(index) {
      if (this.zeroBuyCardShow) {
        return `特权${2 + index}`;
      }
      if (this.goodsList.length < 2) {
        if (this.goodsList[0].propVersion.includes('ride')) {
          return `特权${3 + index}`;
        }
        return `特权${2 + index}`;
      }
      // if (this.goodsList[this.ladderTab].propVersion === 'ride_trial') {
      //   return '特权2';
      // }
      if (this.goodsList && this.goodsList[this.ladderTab].propVersion.includes('ride')) {
        return `特权${3 + index}`;
      }
      if (this.goodsList && this.goodsList[this.ladderTab].propVersion.includes('ladder')) {
        return `特权${2 + index}`;
      }
      return `特权${3 + index}`;
    },
    readOk() {
      this.isRead = true;
      if (this.price.showPopUpWindowType !== 1) {
        let openPrice;
        if (this.transType === 30 || this.transType === 110) {
          if (this.isNba) {
            // eslint-disable-next-line no-nested-ternary
            openPrice = this.nbaPrice.signInfoDTO ? (this.nbaPrice.signInfoDTO.firstSignPrice >= 0 ? this.nbaPrice.signInfoDTO.firstSignPrice : '-') : '-';
          } else {
            // eslint-disable-next-line no-nested-ternary
            openPrice = this.price.signInfoDTO ? (this.price.signInfoDTO.firstSignPrice >= 0 ? this.price.signInfoDTO.firstSignPrice : '-') : '-';
          }
        } else if (this.transType === 60) {
          openPrice = 0;
        } else if (this.isNba) {
          openPrice = (this.nbaPrice.current >= 0 ? this.nbaPrice.current : '-');
        } else {
          openPrice = (this.price.current >= 0 ? this.price.current : '-');
        }
        this.bayCardHandler(null, this.transType, openPrice, this.payChannel, this.planId, this.isNba, this.payActivityInfo);
      } else {
        this.openDialog();
      }
    },
    openRead(payChannel = '', planId = '', isNba = false, payActivityInfo = {}) {
      this.planId = planId;
      this.payChannel = payChannel;
      this.isRead = false;
      this.showRead = true;
      this.isNba = isNba;
      this.payActivityInfo = payActivityInfo;
      // this.isRead = false;
      // this.showRead = true;
      // this.readOk();
    },
    closeScroll() {
      getNoScroll(false);
    },
    goSecond(index) {
      if (index < 3) {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: `platform_coupon${index + 2}`,
          categoryId: 'platform',
          businessInfo: {},
        });
      }
    },
    async checkShowQa() {
      const { token } = await getTokenAndKey();
      let tempGoodsId;
      if (this.showStyleVersion === 'ladderEasy') {
        tempGoodsId = this.goodsList[this.ladderTab].goodsGuid;
      } else {
        tempGoodsId = this.price.goodsGuid;
      }
      try {
        const res = await showQa({
          token,
          action: 'aries.vip.qa.get',
          goodsGuid: tempGoodsId,
        });
        if (res.data) {
          this.showQa = true;
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_QA_membership',
            contentId: 'platform_QA_membership',
            exposureTimes: 1,
            businessInfo: {
              membership_version: this.propVersion === 'normal' ? '1' : '2',
              BusinessLine: res.data.appCode,
            },
          });
        } else {
          this.showQa = false;
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('e', e);
        this.showQa = false;
      }
    },
    goQa() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_QA_membership',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$router.push({
        query: { goodsGuid: this.price.goodsGuid },
        path: '/vip/super/components/qa',
      });
      // commonGoLink(`https://m.hellobike.com/AppPlatformH5/${config.env === 'pro' ? '' : `${config.env}/`}latest/index.html#/vip/super/components/qa?goodsGuid=${this.price.goodsGuid}`);
    },
    openCommonBonus(value, boolean, num) {
      if (!value) return;
      if (boolean) {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: `platform_model${num + 2}`,
          categoryId: 'platform',
          businessInfo: {},
        });
      } else {
        UBT.clickButton({
          pageId: 'platform_savemoneycard_page',
          buttonName: 'platform_Quick_navigation_detail',
          categoryId: 'platform',
          businessInfo: {},
        });
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_Quick_navigation_detail',
          contentId: 'platform_Quick_navigation_detail',
          exposureTimes: 1,
          businessInfo: {},
        });
      }

      this.$refs.onepageup.open(value);
      getNoScroll(true);
    },
    getBigMoney(value) {
      return parseInt(value, 10);
    },
    getSmallMoney(value) {
      if (value % 1 === 0) {
        return '';
      }
      return `${value.toString().substring(value.toString().indexOf('.'), value.length)}`;
    },
    getTransTab(type, price) {
      // 购买订单类型、价格
      this.transType = type;
      if (this.transType !== 60) {
        if (price >= 0 && price !== '-') {
          this.transPrice = price;
        }
      } else {
        this.transPrice = 0;
      }
    },
    openDialog() {
      this.getWaitPayOrder();
    },
    async cancel() {
      const { token } = await getTokenAndKey();
      try {
        await closeVipGoods({
          token,
          action: 'aries.vip.order.closeVipGoods',
          orderNo: this.noPayData.orderNo,
        });
        // Toast.show('取消成功');
        this.getData();
      } catch (e) {
        Toast.showError(e);
      }
    },
    async getWaitPayOrder() {
      const { token } = await getTokenAndKey();
      try {
        const res = await getWaitPayOrder({
          token,
          action: 'aries.vip.order.getWaitPayOrder',
        });
        if (res.data) {
          this.noPayData = res.data;
          UBTUtils.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_pay_Popup',
            contentId: 'platform_pay_Popup',
            exposureTimes: 1,
            businessInfo: {},
          });
          // this.showNopay = true;
          await this.cancel();
        } else {
          // this.showNopay = false;
        }
      } catch (e) {
        Toast.showError(e);
      }
    },
    refreshNopay() {
      this.showNopay = false;
      this.getData();
    },
    closeNew() {
      this.showNopay = false;
    },
    async getData() {
      const isLogin = await Native.isLogin();
      if (!isLogin) {
        this.handleButton();
        return;
      }
      // const { token, cityCode } = await getTokenAndLocation();
      // const { data } = await getSuperVipGoods({
      //   token,
      //   cityCode,
      //   systemCode: 61,
      //   adsource: ParamsUtil.getParam('adsource'),
      // }).catch(() => ({}));
      // if (!data) {
      //   this.handleButton();
      //   return;
      // }

      const {
        groupList = [],
        propVersion,
        goodsList,
        showStyleInfo,
      } = this.vipData;
      this.goodsList = goodsList || [];
      if (this.freeRightsVersion()) {
        // 免单特权数据
        const {
          freeRights = {},
        } = this.vipData;
        this.freeRightsData = freeRights;
      }
      if (showStyleInfo) {
        this.bikeCardShowStyle = showStyleInfo.bikeCardShowStyle;
      }
      this.goodsList.forEach((x) => {
        if (x.propVersion === 'ladder') {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_copuon_card',
            contentId: 'platform_copuon_card',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      });
      this.checkShowQa();
      this.groupList = groupList;
      // this.getBack();
      if (propVersion !== 'normal') {
        let tempMapList;
        if (Array.isArray(this.goodsList) && this.goodsList.length >= 1) {
          this.goodsList.forEach((x) => {
            if (x.ladderPropGroupList) {
              tempMapList = x.ladderPropGroupList;
            }
          });
        }
        if (tempMapList) {
          this.ladderPropGroupList = filterNoOpenData(tempMapList, this.propVersion);
        } else {
          this.ladderPropGroupList = [];
        }
      }
      if (this.goodsList && Array.isArray(this.goodsList)) {
        const goods = this.goodsList[this.ladderTab];
        this.unOpenShowCanBuy = goods.unOpenShowCanBuy;
        this.noSaleType = goods.noSaleType;
        this.price.current = goods.price;
        this.price.goodsGuid = goods.goodsGuid;
        this.save = `${goods.propTotalAmount}`;
        this.centerTitleLift = goods.centerTitleLift;
        this.price.original = goods.markedPrice;
        this.price.couponEndTime = goods.couponEndTime;
        this.price.showPopUpWindowType = goods.showPopUpWindowType;
        this.price.signInfoDTO = goods.signInfoDTO;
        this.transPrice = goods.signInfoDTO ? goods.signInfoDTO.firstSignPrice || '-' : '-';
        this.fullRefundUnusedShowAb = goods.fullRefundUnusedShowAb;
        this.cardPurchaseSuggestionDTO = goods.cardPurchaseSuggestionDTO;
        this.showSpecialExpiredAb = goods.showSpecialExpiredAb;
        this.expiredUserInfoDTO = goods.expiredUserInfoDTO || {};
        this.buyingAdviceAB = goods.buyingAdviceAB;
        this.unOpenCouponGameAB = goods.unOpenCouponGameAB || false;
        this.signPayChannels = goods.signPayChannels || [];
        this.vipRecommendText = goods.vipRecommendText || '';
        this.vipRecommendPic = goods.vipRecommendPic || '';
        if (this.fullRefundUnusedShowAb) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_refund',
            contentId: 'platform_refund',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
        if (goods.moduleInfos && Array.isArray(goods.moduleInfos)) {
          const tempGiftList = goods.moduleInfos.filter((i) => i.moduleCode === 'openCeremony');
          if (tempGiftList.length > 0 && tempGiftList[0].moduleData) {
            this.giftList = tempGiftList[0].moduleData.bonus;
          } else {
            this.giftList = [];
          }
        }
        this.commonBonus = goods.commonBonus;
        this.autoRenewalStatus = goods.autoRenewalStatus;
        this.taurusTaskUnOpenShowSort = goods.taurusTaskUnOpenShowSort;
        this.ladderDetailMap = goods.ladderDetailMap || {};
        this.propVersion = goods.propVersion;
        this.currentRideCard = goods.currentRideCard;
        this.zeroBuyCardShow = !!this.currentRideCard;
        if (this.zeroBuyCardShow) {
          UBT.moduleExpose({
            pageId: 'platform_savemoneycard_page',
            categoryId: 'platform',
            moduleId: 'platform_0yuan_button',
            contentId: 'platform_0yuan_button',
            exposureTimes: 1,
            businessInfo: {},
          });
        }
      }
      if (this.autoRenewalStatus === RENEWAL_STATUS.unavailable) {
        this.transType = 0;
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_nochoosebutton',
          contentId: 'platform_nochoosebutton',
          exposureTimes: 1,
          businessInfo: {
            typeandprice: `2&${this.price.current}`,
          },
        });
      } else {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: 'platform_type_choose',
          contentId: 'platform_type_choose',
          exposureTimes: 1,
          businessInfo: {
            typeandprice: `1&${this.price.signInfoDTO ? this.price.signInfoDTO.firstSignPrice : null};2&${this.price.current}`,
          },
        });
      }
      let tempList = [];
      tempList = this.goodsList[this.ladderTab].groupList;
      if (tempList) {
        this.groups = filterNoOpenData(tempList, this.propVersion);
      }

      [this.groupsOne, ...this.groupsOther] = this.groups;
      this.groupsOther.forEach((i, index) => {
        UBT.moduleExpose({
          pageId: 'platform_savemoneycard_page',
          categoryId: 'platform',
          moduleId: `platform_coupon${index + 1}`,
          contentId: `platform_coupon${index + 1}`,
          exposureTimes: 1,
          businessInfo: {},
        });
      });
      if (this.commonBonus && this.commonBonus.length) {
        this.otherList = this.commonBonus.filter(
          (i) => (i.bonusEntity && i.bonusEntity.unPayImage !== '' && i.bonusEntity.unPayImage)
            || i.bonusType === RIGHT_TYPE.freeRight,
        );

        this.freeRightDisplayItem = this.commonBonus.find((item) => item.bonusType === RIGHT_TYPE.freeRight) || null;
        if (this.otherList && this.otherList.length) {
          this.otherList.forEach((i, index) => {
            UBT.moduleExpose({
              pageId: 'platform_savemoneycard_page',
              categoryId: 'platform',
              moduleId: `platform_model${index + 1 + this.groupsOther.length}`,
              contentId: `platform_model${index + 1 + this.groupsOther.length}`,
              exposureTimes: 1,
              businessInfo: {},
            });
          });
        }
      }


      if (
        this.taurusTaskUnOpenShowSort === '2'
        && this.showStyleVersion !== 'ladderEasy'
      ) {
        // eslint-disable-next-line prefer-destructuring
        this.testSecondList = this.otherList[0];
        this.testSecondList.length = 1;
        // this.otherList.splice(0, 1);
      }
      this.haveData = true;
      this.handleButton();
    },
    // getBack() {

    // },
    handleButton() {
      this.$nextTick(() => {
        let btn = null;
        if (this.autoRenewalStatus === RENEWAL_STATUS.unavailable) {
          btn = this.$refs.button;
        } else {
          btn = this.$refs.buttonNew;
        }
        if (btn) {
          // btn.locate();
          // this.$nextTick(() => {
          //   const { classes } = btn;
          //   if (classes && classes.fixed) {
          //     this.groupsClass.radius = true;
          //   }
          // });
        }
      });
    },
    handleBack() {
      Native.closeWebView();
    },
    // initCashier() {
    //   if (isH5()) {
    //     return;
    //   }
    //   const instance = new Cashier();
    //   this.cashier = instance;
    //   instance.setEnv(this.envValue); // 仅针对小程序端
    // },
    /**
     * 购买会员卡处理函数
     * @param {*} val - 订单类型标识，true表示零元购
     * @param {number} num - 订单操作类型：ORDER_TYPE
     * @param {number} money - 支付金额
     * @param {string} payChannel - 支付渠道，默认为空字符串
     * @param {string} planId - （微信小程序连续包月）套餐计划ID，默认为空字符串
     * @param {boolean} isNba - 是否为NBA相关订单，默认为false
     */
    async bayCardHandler(val, num, money, payChannel = '', planId = '', isNba = false, payActivityInfo = {}) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payChannel = payChannel;
      this.planId = planId;
      this.payActivityInfo = payActivityInfo;
      const { token, cityCode, adCode } = await getTokenAndLocation();
      if (!token) {
        Toast.show('请先登录');
        return;
      }
      let tempMoney = null;
      if ([ORDER_TYPE.CONTINUOUS_MONTHLY,
        ORDER_TYPE.RIDE_TRIAL_ZERO,
        ORDER_TYPE.UNION_CONTINUOUS_MONTH].includes(num)) {
        tempMoney = money;
      } else if (isNba) {
        tempMoney = this.nbaPrice.current;
      } else {
        tempMoney = this.price.current;
      }
      const toPost = {
        cityCode,
        adCode,
        token,
        ...(isNba ? this.nbaPrice : this.price || {}),
        ...{
          price: tempMoney,
        },
        systemCode: getSystemCode(),
        orderOptType: num || ORDER_TYPE.SINGLE_MONTH,
      };
      if ((num === ORDER_TYPE.CONTINUOUS_MONTHLY || num === ORDER_TYPE.RIDE_TRIAL_ZERO) && !toPost.price) {
        // eslint-disable-next-line no-console
        CardService.signWithoutPasswordContract().then(() => this.buyGoods(num, toPost, val));
      } else {
        this.buyGoods(num, toPost, val);
      }
    },
    /**
     * 购买会员卡处理函数
     * @param {*} val - 订单类型标识，true表示零元购
     * @param {number} num - 订单操作类型：ORDER_TYPE
     */
    buyGoods(num, toPost, val) {
      if (this.payingFlag) {
        Toast.show('正在支付中，请稍候');
        return;
      }
      this.payingFlag = true;
      // 创单
      buyVipGoods(toPost)
        .then(async (v) => {
          const { token } = await getTokenAndKey();
          if (v && v.data) {
            const {
              loopIntervalSecond,
              orderNo,
              loopTotalSecond,
              showPopUpWindowType,
            } = v.data;

            // 微信小程序环境
            if (env.isWechatMini) {
              if (num === ORDER_TYPE.CONTINUOUS_MONTHLY) {
                // 连续包月
                if (showPopUpWindowType === 1) {
                  // 有未支付订单
                  await this.getWaitPayOrder();
                  setTimeout(() => {
                    this.payingFlag = false;
                    this.buyGoods(num, toPost, val);
                  }, 10);
                  return;
                }
                await CardService.evokePageAndSign(v.data, this.planId);
                this.nbaShow = false;
                return;
              }
              // 直接买一个月
              window.location.href = ParamsUtil.addParams(window.location.href, {
                loopIntervalSecond,
                orderNo,
                loopTotalSecond,
              });
            }

            // 有未支付订单且非零元购
            if (showPopUpWindowType === 1 && (!val || val === 0)) {
              await this.getWaitPayOrder();
              this.payingFlag = false;
              setTimeout(() => {
                this.buyGoods(num, toPost, val);
              }, 10);
            } else if (toPost.price) {
              // 有价格
              // eslint-disable-next-line no-lonely-if
              if (num !== ORDER_TYPE.CONTINUOUS_MONTHLY && num !== ORDER_TYPE.UNION_CONTINUOUS_MONTH && this.propVersion !== PropVersionMap.RIDE_ONE_CENT) {
                // 单月购买：连续包月、1分骑单月购买以外的
                setTimeout(() => {
                  this.payingFlag = false;// 由于buy方法未推进promise状态 拉起比较迅速 所以直接置为没正在支付
                }, 1000);
                await CardService.buyMember(v.data)
                  .then(() => {
                    this.nbaShow = false;
                    this.searchStatus(
                      {
                        token,
                        orderNo,
                        loopIntervalSecond,
                        loopTotalSecond,
                      },
                      num,
                    );
                  })
                  .catch((e) => {
                    if (e) {
                      Toast.showError(e);
                    }
                  });
              } else if (!env.isEasyBikeApp
                && !env.isAlipayBrowser && !env.isAliMP && !env.isWechatMini) {
                // 端外环境
                const queryRedirectUrl = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/vip/v2/transfer`;
                const baseQuery = `redirectUrl=${encodeURIComponent(
                  queryRedirectUrl,
                )}&h5Login=1`;
                const schemeQuery = config.env === 'fat' ? baseQuery : `codeEnv=${config.env}&${baseQuery}`;
                const scheme = `alipays://platformapi/startapp?appId=2017050407110255&page=/pages/index/index&query=${encodeURIComponent(
                  schemeQuery,
                )}`;
                window.location.href = scheme;
              } else {
                // 连续包月
                let data = { ...v.data };
                if (this.propVersion === PropVersionMap.RIDE_ONE_CENT) {
                  // 一分骑走抖音签约,抖音签约参数
                  const isContinuous = [ORDER_TYPE.CONTINUOUS_MONTHLY, ORDER_TYPE.UNION_CONTINUOUS_MONTH].includes(num);
                  const channel = isContinuous ? '2309' : '2304';
                  const extension = isContinuous
                    ? {
                      planId: '', // 无需传planId，就会有兜底planId
                      signMustPay: true,
                      attachSceneType: 'RIDE',
                    }
                    : {
                      signMustPay: true,
                    };
                  const { productTagForDySign = '', bizScene = '' } = this.payActivityInfo || {};
                  data = {
                    ...v.data,
                    channelOperationInfoExt: {
                      productTagForDySign,
                      biz_scene: bizScene,
                    },
                    channel,
                    extension,
                  };
                } else if (this.payChannel) {
                  data.signChannel = this.payChannel;
                  if (this.planId || env.isWeixin || env.isWechatMini) {
                    data.extension = {};
                    data.extension.planId = this.planId;
                  }
                }
                await CardService.buyContinueMember(data)
                  .then(() => {
                    this.nbaShow = false;
                    this.searchStatus(
                      {
                        token,
                        orderNo,
                        loopIntervalSecond,
                        loopTotalSecond,
                      },
                      num,
                    );
                  })
                  .catch((e) => {
                    if (e) {
                      Toast.showError(e);
                    }
                  });
              }
            } else {
              // 无价格
              this.searchStatus(
                {
                  token,
                  orderNo,
                  loopIntervalSecond,
                  loopTotalSecond,
                },
                num,
              );
            }
          } else if (v.code === 103) {
            Toast.show('登录信息已失效, 请重新登录');
          }
        })
        .catch((e) => {
          Toast.showError(e);
          this.$emit('refresh');
        })
        .finally(() => {
          this.payingFlag = false;
        });
    },
    // 轮询付费会员状态
    async searchStatus({
      token, orderNo, loopIntervalSecond = 1, loopTotalSecond = 5,
    }) {
      // loopIntervalSecond 轮询间隔时间
      // loopTotalSecond 轮询总时间
      // 重置计数器
      this.curloopIntervalSecond = 0;

      const poll = async () => {
        if (this.curloopIntervalSecond >= loopTotalSecond) {
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          return;
        }

        try {
          const { data, msg } = await tryTakeOrderStatus({
            token,
            orderNo,
            systemCode: getSystemCode(),
          });


          if (data) {
            const { status } = data;

            // 订单交易中，继续轮询
            if (status === ORDER_STATUS.padding) {
              this.curloopIntervalSecond += loopIntervalSecond;
              this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);// 更新timer
              return;
            }

            // 清除定时器
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }

            UBT.clickButton({
              pageId: 'platform_PurchasePage',
              buttonName: 'platform_ToPurchase',
              categoryId: 'platform',
              businessInfo: {
                adsource: getSource(),
                TransactionResults: (() => {
                  if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
                    return 0;
                  }
                  if (status === ORDER_STATUS.success) {
                    return 1;
                  }
                  return '';
                })(),
              },
            });

            // 订单成功
            if (status === ORDER_STATUS.success) {
              if (!this.showAppExpensive) {
                this.$refs.complete.open();
              } else {
                this.showAppPrivilege = true;
                UBT.moduleExpose({
                  pageId: 'platform_openedcard_page',
                  categoryId: 'platform',
                  moduleId: 'platform_VIPappPOP',
                  contentId: 'platform_VIPappPOP',
                  exposureTimes: 1,
                  businessInfo: {},
                });
              }
            }

            // 订单失败
            if (status === ORDER_STATUS.fall || status === ORDER_STATUS.closed) {
              Toast.show('正在支付中，请稍候查看');
              this.$router.go(-1); // 为什么回退？
            }
          } else {
            // API 调用失败，停止轮询
            if (this.orderTimer) {
              clearTimeout(this.orderTimer);
              this.orderTimer = null;
            }
            Toast.show(msg);
          }
        } catch (error) {
          // 处理异常，停止轮询
          if (this.orderTimer) {
            clearTimeout(this.orderTimer);
            this.orderTimer = null;
          }
          Toast.show('查询订单状态失败');
        }
      };

      // 开始轮询
      this.orderTimer = setTimeout(poll, loopIntervalSecond * 1000);
    },
    async goCardComplete() {
      getNoScroll(false);
      await redirectToCardComplete();
    },
    goBack() {
      Native.goBack();
    },
    rule() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_buycardrecord',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      window.onpageshow = null;
      window.addEventListener('pageshow', () => {
        window.location.reload();
      });
      Navigator.go(
        'https://m2.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920',
        { isRuleLink: true },
      );
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  background: #f0f4f7;
}

.super-container {
  background-position: top;
  background-repeat: no-repeat;
  background-size: 100%;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    color: transparent;
  }

  .header {
    .top-left-line {
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/Ylp78_logo%202.png?x-oss-process=image/format,webp);
      background-size: 100% 100%;
      width: 1.05rem;
      height: 0.18rem;
      margin-top: 0.03rem;
    }

    .middle-img {
      img {
        width: 1.45rem;
        height: 0.2rem;
      }
    }

    .header-menu {
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/x4P3I_Slice%206.png?x-oss-process=image/format,webp);
      background-size: 100% 100%;
      width: 0.83rem;
      height: 0.24rem;
      margin-top: 0.03rem;
    }
  }

  .haveData {
    .ladder-have-test {
      padding-top: 0.12rem;

      .ladder-tab {
        height: 0.5rem;
        width: 100%;
      }

      .purchase-one-cent {
        margin-left: 0.16rem;
        width: 3.59rem;
        height: 0.63rem;
      }

      .purchase-block {
        margin-left: 0.16rem;
        display: flex;
        background-image: url(https://m.hellobike.com/resource/gallery/511/yNuhfvuK_Group%201707482213.png?x-oss-process=image/quality,q_80);
        background-size: 100% 100%;
        width: 3.59rem;
        height: 0.63rem;

        .purchase-block-left {
          height: 0.6rem;
          width: 2.77rem;

          .left-purchase-line-one {
            display: flex;
            padding-top: 0.05rem;
            padding-left: 0.44rem;
            margin-bottom: -0.06rem;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-size: 0.16rem;
            font-weight: 400;
            color: #b34a00;

            .left-purchase-line-one-word {
              line-height: 0.32rem;
            }
          }

          .left-purchase-line-two {
            padding-left: 0.44rem;
            font-family: PingFang SC, sans-serif;
            font-size: 0.12rem;
            font-weight: 400;
            color: #b34a00;

            .red-word {
              color: #f72626;
              font-weight: 500;
            }
          }
        }
      }

      .ladderTest {
        margin-top: -0.52rem;
      }

      .ladderTestbig {
        margin-top: -0.2rem;
      }

      .bikeMonthCard {
        width: 3.51rem;
        height: 1.3rem;
        background: url(https://m.hellobike.com/resource/helloyun/wb26923/VAewHezZY1.png?x-oss-process=image/quality,q_80);
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        margin: 0.03rem auto;

        .card-top {
          display: flex;
          align-items: center;
          height: 0.44rem;

          .icon {
            width: 0.57rem;
            height: 0.18rem;
            margin-left: 0.15rem;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .text {
            font-size: 0.15rem;
            color: #242729;
            margin-left: 0.05rem;
            font-weight: 500;
          }
        }

        .card-bottom {
          width: 3.21rem;
          height: 0.72rem;
          background: url(https://m.hellobike.com/resource/helloyun/wb26923/f2cSl_Rectangle%20106.png?x-oss-process=image/quality,q_80);
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          margin: 0 auto;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;

          .left {
            float: left;
            padding-top: 0.17rem;
            padding-left: 0.16rem;
            display: flex;
            flex-direction: column;

            .topContext {
              font-size: 0.16rem;
              font-weight: 500;
              color: #5a6066;
            }

            .botContext {
              font-size: 0.12rem;
              color: #7d3b2a;
              margin-top: 0.03rem;
            }
          }

          .right {
            float: right;
            margin-top: 0.17rem;
            margin-right: 0.21rem;
            font-size: 0.14rem;

            .font {
              margin-left: -0.03rem;
              text-align: center;
              font-size: 0.26rem;
              color: #5a6066;
              margin-right: 0.03rem;
            }
          }
        }
      }

      .other-block-test {
        .other-block-item {
          margin: 0 0.12rem 0 0.12rem;
          position: relative;

          .other-title-img {
            position: absolute;
            top: 0.14rem;
            left: 0.15rem;

            .top-sign {
              background: linear-gradient(90deg, #76737c 0%, #36363c 100%);
              height: 0.18rem;
              border-radius: 0.1rem 0.02rem 0.1rem 0.02rem;
              color: #fffae8;
              font-size: 0.12rem;
              text-align: center;
              line-height: 0.18rem;
              padding: 0 0.05rem;
              margin-right: 0.05rem;
            }
          }

          .other-top-line {
            width: 100%;
            height: 0.46rem;
          }

          img.under-img {
            width: 100%;
          }
        }
      }

      .no-use {
        margin: 0.08rem 0.12rem 0.1rem 0.12rem;
        width: 3.51rem;
        height: 0.5rem;
        background: #fff;
        border-radius: 0.16rem;
        display: flex;
        justify-content: space-between;
        padding: 0.12rem 0.15rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.15rem;
        color: #242729;
        line-height: 0.26rem;
        border: 0.01rem solid #ebeef0;

        .no-use-left {
          display: flex;

          img.no-use-img {
            margin-right: 0.03rem;
            width: 0.26rem;
            height: 0.26rem;
          }
        }

        .no-use-right {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.14rem;
          color: #5a6066;

          img.no-use-flag {
            margin-left: 0.03rem;
            width: 0.1rem;
            height: 0.1rem;
          }
        }
      }

      .qa-and-suggest {
        display: flex;
        justify-content: space-around;
        margin: 0.08rem 0.12rem 0.2rem 0.12rem;
        height: 0.69rem;

        .suggest-block {
          background: #fff;
          border-radius: 0.12rem;
          padding: 0.14rem 0 0 0.12rem;
          height: 100%;
          width: 1.72rem;

          .suggest-title {
            font-family: PingFangSC-Medium, sans-serif;
            font-size: 0.16rem;
            color: #242729;
            font-weight: 500;
            margin-bottom: 0.05rem;
            display: flex;

            .qa-go {
              img {
                width: 0.15rem;
                height: 0.15rem;
              }
            }
          }

          .suggest-word {
            margin-top: 0.04rem;
            font-family: PingFangSC-Regular, sans-serif;
            font-size: 0.14rem;
            color: #879099;
            font-weight: 400;
          }
        }

        .qa-block {
          background: #fff;
          border-radius: 0.12rem;
          display: flex;
          justify-content: space-between;
          padding: 0.14rem 0 0 0.12rem;
          height: 100%;
          width: 1.71rem;

          .qa-left {
            .qa-title {
              font-family: PingFangSC-Medium, sans-serif;
              font-size: 0.16rem;
              color: #242729;
              font-weight: 500;
              margin-bottom: 0.05rem;
              display: flex;

              .qa-go {
                img {
                  width: 0.15rem;
                  height: 0.15rem;
                }
              }
            }

            .qa-word {
              margin-top: 0.04rem;
              font-family: PingFangSC-Regular, sans-serif;
              font-size: 0.14rem;
              color: #879099;
              font-weight: 400;
            }
          }
        }
      }

      .rule-block {
        text-align: center;
        width: 100%;
        margin: 0 auto;
        font-size: 0.13rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #879099;
        line-height: 0.18rem;
        padding-bottom: 0.28rem;
        background: #f0f4f7;
        margin-top: 0.15rem;
      }

      .shark-block {
        background: #f4f5f7;
        height: 2rem;
        width: 100%;
      }
    }
  }

  .no-scroll {
    overflow: hidden;
  }
}

.super-container-ladder {
  background-image: url(https://m.hellobike.com/resource/gallery/511/VghXUSZP_Group%201707482289.png?x-oss-process=image/quality,q_80);
  background-repeat: no-repeat;

  /* 避免平铺 */
  background-position: top center;
  margin-top: 0.88rem;
}

.noData {
  height: 100vh;
  width: 100%;
  background: linear-gradient(#fffbeb, #fff);
  padding-top: 2.85rem;

  .noData-img {
    display: flex;
    justify-content: center;
    align-items: center;

    img.nodata-gif {
      margin: 0 auto;
      width: 0.4rem;
      height: 0.4rem;
    }
  }

  .noData-word {
    margin-top: 0.18rem;
    text-align: center;
    font-family: PingFang SC, sans-serif;
    font-size: 0.12rem;
    font-weight: 500;
    line-height: 0.17rem;
    color: #879099;
  }
}

.new-h5-version {
  .main {
    background: linear-gradient(181.29deg, #fff 0.337rem, #f0f3f5 1.34rem);
  }
}

.new-h5-version.single-vip {
  .main {
    background: linear-gradient(180deg, #fff4e2 0%, #fff 0.13rem, #f9f9f9 0.337rem);
    border-radius: 0.12rem;
    box-shadow: 0 -0.01rem 0 0 #fff;
  }
}

.free-rights-version {
  .main {
    background: linear-gradient(181.29deg, #f9f0ec 10%, #eef2f5 14.91%);
  }

  .super-container {
    .haveData {
      .ladder-have-test {
        padding-top: 0;

        .ladderTest {
          margin-top: 0;
        }

        .other-block-test {
          .other-block-item {
            margin: 0.08rem 0.08rem 0 0.08rem;
          }
        }

        .no-use {
          margin: 0.08rem auto 0.1rem;
          padding: 0.12rem 0.21rem 0.12rem 0.093rem;
          width: 3.59rem;
          height: 0.5rem;
          flex-shrink: 0;
          background: #fff;

          .no-use-right {
            display: flex;
            align-items: center;
            color: #5a6066;
            font-size: 0.14rem;
            font-weight: 400;

            img.no-use-flag {
              margin-left: 0.057rem;
              width: 0.04rem;
              height: 0.08rem;
            }
          }
        }

        .shark-block {
          background-color: #0a1533;
          height: 1.51rem;
        }
      }
    }
  }
}
</style>
